<template>
    <div>
        <table>
            <tr>
                <th width="10%">{{thPlayerName}}</th>
                <th v-for="(item, index) of header" :key="item.id" :width="90/(header.length)+'%'">第{{index+1}}场</th>
            </tr>
            <tr class="race-info">
                <th width="10%">比赛信息</th>
                <th v-for="item of races" :key="item.id">
                    <p>{{item.name}}</p>
                    <p>{{item.time}}</p>
                </th>
            </tr>
            <tr v-for="item of list" :key="item.id">
                <td>{{item[indexName]}}</td>
                <td class="horse-name" v-for="itemT of item.races" :key="itemT.id">
                    <div v-if="!itemT.isNull">
                        <p v-for="itemF of itemT.horseList" :key="itemF.id">{{itemF.name}}</p>
                    </div>
                </td>
            </tr>
        </table>
    </div>
</template>

<script>
    export default{
        name: "PlayerTable",
        props: {
            header: Array,
            races: Array,
            list: Array,
            indexName: String,
            thPlayerName: String
        }
    }
</script>

<style scoped>
    table {
        width: 100%;
        text-align: center;
        color: #666;
        border-collapse: collapse;
    }
    td, th {
        border: 1px solid #eee;
    }
    th {
        padding: .5rem;
        overflow: hidden;
    }
    .race-info p {
        font-size: 12px;
        color: #999;
        font-weight: lighter !important;
    }
    .horse-name {
        font-size: 12px;
        color: #00c0ff;
    }
    .horse-name p {
        margin: 5px;
        padding: 2px 5px;
        display: inline-block;
        border: 1px solid #00c0ff;
        border-radius: 3px;
        width: auto;
    }
</style>